export default __webpack_public_path__ + "static/media/ProximaNova-Regular.ea03f826.otf";